if (typeof complementaryProductsComponent === 'undefined')
{   
    class ComplementaryProductsComponent extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            // First try to init swiper on the markup already rendered by Liquid.
            // Fallback to fetching recommendations if markup is missing/empty.
            const productCarousel = this.querySelector('.complementary-products-swiper');
            if (productCarousel && productCarousel.querySelector('.swiper-slide')) {
                this.initializeSlider(productCarousel);
                return;
            }

            const url = this.dataset.url;
            this.buildProducts(url);
        }

        buildProducts(url) {
            const fetchProducts = async (url) => {
                const res = await fetch(url);
                let text = await res.text();

                const html = document.createElement('div');
                text = text
                    .replaceAll('variant-selects', 'div')
                    .replaceAll('variant-radios', 'div')
                    .replaceAll('product-tab', 'div')
                    .replaceAll('compare-color', 'div')
                    .replaceAll('breadcrumb-component', 'div');
                html.innerHTML = text;

                const recommendations = html.querySelector('[data-complementary-product]');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;

                    if (window.sharedFunctions.checkNeedToConvertCurrency()) {
                        Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                    }
                }

                const productCarousel = this.querySelector('.complementary-products-swiper');
                this.initializeSlider(productCarousel);
            }

            fetchProducts(url);
        }
        
        initializeSlider(productCarousel = null) {
            if (productCarousel && typeof Swiper !== 'undefined') {
                const slidesToShow = parseInt(productCarousel.dataset.slidesToShow) || 3;
                const autoplayEnabled = productCarousel.dataset.autoplay === 'true';

                if (!productCarousel.classList.contains('swiper-initialized')) {
                    const swiperConfig = {
                        //slidesPerView: 3,
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        loop: true,
                        speed: 600,
                        grabCursor: true,
                        autoplay: autoplayEnabled ? { delay: 3000 } : false,
                        /*breakpoints: {
                            1358: { slidesPerView: 3 },
                            768: { slidesPerView: 2 },
                            624: { slidesPerView: 3 },
                            200: { slidesPerView: 2 }
                        },*/

                        on: {
                            init: () => {
                                this.calculateCard06Padding();
                            }
                        }
                    };

                    if (window.rtl_swiper) {
                        swiperConfig.dir = 'rtl';
                    }

                    new Swiper(productCarousel, swiperConfig);
                    productCarousel.classList.add('swiper-initialized');
                }
            }
        }
        
        calculateCard06Padding() {
            if (!document.body.classList.contains('product-card-layout-06')) return;

            const selectOptionsHeight = this.querySelector('.product .card-action').scrollHeight;
            this.querySelector('.swiper-wrapper').style.paddingBottom = selectOptionsHeight + 'px';
        }
    }
    
    window.addEventListener('load', () => {
        customElements.define('complementary-products', ComplementaryProductsComponent);
    })

    var complementaryProductsComponent = ComplementaryProductsComponent;
}
